import { Page } from "@/components/PublicLayout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FreelyGiven } from "@/components/FreelyGiven";
import { useFaq } from "@/hooks/useContent";

export default function FaqPage() {
  const { data: items = [] } = useFaq();
  return (
    <Page title="Frequently Asked Questions" lede="Plain answers about care at Patria. If your question is not here, reach out and we will answer it." testId="faq-page">
      <Accordion type="multiple" className="max-w-2xl border-t border-sage-400/50" data-testid="faq-list">
        {items.map((item) => (
          <AccordionItem key={item.id} value={item.id} className="border-sage-400/50">
            <AccordionTrigger className="py-5 text-left font-serif text-xl font-semibold hover:no-underline min-h-[44px]" data-testid={`faq-question-${item.id}`}>{item.question}</AccordionTrigger>
            <AccordionContent className="pb-6 text-base leading-relaxed max-w-[65ch]" data-testid={`faq-answer-${item.id}`}>
              {item.answer}
              {item.attach_block === "shared.freely_given" && <FreelyGiven variant="inline" testId={`faq-giving-${item.id}`} />}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Page>
  );
}
